function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { PureComponent } from 'react';
import { node, string, oneOf, bool, func } from 'prop-types';
import cx from 'classnames';
import { getColorByString } from '@foxford/foxford-utils';
import { makeParamsObjFromSassMap } from './../../utils/helpers';
import { UI } from './../../utils';
import { getAvatarText as _getAvatarText } from './utils/getAvatarText';
import css from './Avatar.sass';
var SIZES =
/*#__PURE__*/
makeParamsObjFromSassMap(css.sizes);
/**
 * Component for displaying user's avatar.
 *
 * @author Natalya Ch.
 * @author Roman O.
 */

var Avatar =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Avatar, _PureComponent);

  function Avatar() {
    _classCallCheck(this, Avatar);

    return _possibleConstructorReturn(this, _getPrototypeOf(Avatar).apply(this, arguments));
  }

  _createClass(Avatar, [{
    key: "getAvatarText",
    value: function getAvatarText() {
      return _getAvatarText(this.props.title);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          src = _this$props.src,
          makeRef = _this$props.makeRef,
          title = _this$props.title,
          shadow = _this$props.shadow,
          children = _this$props.children,
          size = _this$props.size,
          color = _this$props.color,
          autoColor = _this$props.autoColor;
      var text = this.getAvatarText();
      var avatarColor = autoColor && title ? getColorByString(title, Object.keys(UI.COLORS)) : color;
      var className = cx(css.root, css["size-".concat(size)], this.props.className, shadow && css.shadow, src ? css.withImage : css.withPlaceholder, avatarColor && css[avatarColor]);

      if (src) {
        return React.createElement("div", {
          className: className,
          ref: makeRef,
          title: title,
          style: {
            backgroundImage: src && "url(".concat(src, ")")
          }
        }, children);
      }

      return React.createElement("div", {
        className: className,
        title: title
      }, text);
    }
  }]);

  return Avatar;
}(PureComponent);
/* Default exports will be deprecated soon, use named exports instead */


_defineProperty(Avatar, "size", makeParamsObjFromSassMap(css.sizes));

_defineProperty(Avatar, "propTypes", {
  children: node,

  /** Title for avatar. Example user name. */
  title: string,

  /** Image source */
  src: string,

  /** Size of avatar */
  size: oneOf(Object.keys(SIZES)),

  /** Shadow of avatar */
  shadow: bool,

  /** Class */
  className: string,

  /** Make ref func */
  makeRef: func,

  /** Background color of avagtar */
  color: oneOf(Object.keys(UI.COLORS)),

  /**
   * Generate color by title automatically
   *
   * `Performance Info`: Each render of component call getAvatarColor function on received title
   */
  autoColor: bool
});

_defineProperty(Avatar, "defaultProps", {
  size: 'm',
  autoColor: false
});

export { Avatar };